import { api } from '@/fsd/shared/api';
import {
  IGetAccountCabinetOnboardingStateResultOne,
  IGetAccountCabinetOnboardingStateResultTwo,
} from '../../model/types/IGetAccountCabinetOnboardingStateResult';

export const getAccountCabinetOnboardingState = async () => {
  const result = await api.get<
    | IGetAccountCabinetOnboardingStateResultOne
    | IGetAccountCabinetOnboardingStateResultTwo
  >(`/api/v1/account/cabinet/onboarding/state/`);

  return result;
};
